/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiTransactiontypeGet } from '../fn/transaction-type/api-transactiontype-get';
import { ApiTransactiontypeGet$Params } from '../fn/transaction-type/api-transactiontype-get';
import { TransactionTypeDto } from '../models/transaction-type-dto';

@Injectable({ providedIn: 'root' })
export class TransactionTypeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiTransactiontypeGet()` */
  static readonly ApiTransactiontypeGetPath = '/api/transactiontype';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTransactiontypeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactiontypeGet$Response(params?: ApiTransactiontypeGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TransactionTypeDto>>> {
    return apiTransactiontypeGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTransactiontypeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTransactiontypeGet(params?: ApiTransactiontypeGet$Params, context?: HttpContext): Observable<Array<TransactionTypeDto>> {
    return this.apiTransactiontypeGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TransactionTypeDto>>): Array<TransactionTypeDto> => r.body)
    );
  }

}
